<template>
  <div class="dimmed" v-if="model">
    <div class="filter__layer">
      <div class="filter__scroll">
        <div class="options--wrap top">
          <strong>{{ $t('funnel.filter.visitProp') }}</strong>

          <div class="option__next-page">
            <label for="optionNextPage">
              {{ $t('common.table.header.nextPage') }}
            </label>
            <ui-selectbox id="optionNextPage"
                          class="full-size"
                          :width="570"
                          :class="{ disabled: 'funnel.flow.type' === 'inflow'}"
                          :useRawText="true"
                          v-model="model.cvr"
                          :items="getOptionItems('cvr')"/>
          </div>

          <div class="option__duration">
            <label for="optionDuration">
              {{ $t('common.table.header.duration') }}
            </label>
            <div class="row">
              <ui-selectbox id="optionDuration"
                            class="left"
                            :width="270"
                            v-model="model.sessionGteTime"
                            :items="durationStartItems"/>
              <span>~</span>
              <ui-selectbox class="right"
                            :width="270"
                            v-model="model.sessionLteTime"
                            :items="durationEndItems"/>
            </div>
          </div>
        </div>

        <div class="options--wrap bottom">
          <strong>{{ $t('funnel.filter.userProp') }}</strong>

          <div class="row first-row">
            <div class="option__id">
              <label for="optionId">
                {{ $t('common.table.header.sessionId') }}
              </label>
              <input type="text" id="optionId"
                :placeholder="$t('common.table.header.sessionId')"
                v-model="model.sessionId">
            </div>

            <div class="option__user-type">
              <label for="optionUserType">{{ $t('common.table.header.userType') }}</label>
              <ui-selectbox id="optionUserType"
                            :width="270"
                            v-model="model.existing"
                            :items="getOptionItems('existing')"/>
              <!-- todo: disabled 조건 있음 funnel.funnelData.disableExistingData -->
            </div>
          </div>

          <div class="row">
            <div class="option__location">
              <label for="optionLocation">{{ $t('common.table.header.location') }}</label>
              <ui-selectbox id="optionLocation"
                            class="left"
                            :width="270"
                            :maxHeight="192"
                            :direction="'top'"
                            v-model="model.country"
                            :items="getOptionItems('country')"/>
            </div>

            <div class="option__device">
              <label for="optionDevice">{{ $t('common.table.header.device') }}</label>
              <ui-selectbox id="optionDevice"
                            :width="270"
                            :maxHeight="192"
                            :direction="'top'"
                            v-model="model.device"
                            :items="getOptionItems('device')"/>
            </div>
          </div>

          <div class="row">
            <div class="option__os">
              <label for="optionsOS">{{ $t('common.table.header.os') }}</label>
              <ui-selectbox id="optionsOS"
                            class="left"
                            :width="270"
                            :maxHeight="192"
                            :direction="'top'"
                            v-model="model.os"
                            :items="getOptionItems('os')"/>
            </div>

            <div class="option__browser">
              <label for="optionBrowser">{{ $t('common.table.header.browser') }}</label>
              <ui-selectbox id="optionBrowser"
                            :width="270"
                            :maxHeight="192"
                            :direction="'top'"
                            v-model="model.browser"
                            :items="getOptionItems('browser')"/>
            </div>
          </div>
        </div>
      </div>

      <div class="button--wrap">
        <button class="btn__cancel" @click="$emit('update:showFilter', false)">
          {{ $t('common.cancel') }}
        </button>
        <button class="btn__apply" @click="$emit('onApplyClick', model)">
          {{ $t('common.apply') }}
        </button>
        <button class="btn__reset" @click="$emit('onCancelClick')">
          <i class="icon icon--reset-size16"></i>
          <span>{{ $t('common.reset') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from '@/libs/utils'
import UiSelectbox from '@/components/ui/UiSelectbox'

const DURATIONS = ['0초', '10초', '30초', '1분', '2분', '3분', '4분', '5분', '10분', '20분', '30분', '1시간', '2시간', '5시간']
const NUMBER_REGEX = /^\d+/

function durationStrToSec (text, i18n) {
  let value

  if (text === '∞') {
    value = null
  } else {
    const unit = text.replace(NUMBER_REGEX, '')
    const intValue = parseInt(text)
    switch (unit) {
      case '초':
        value = intValue
        text = `${intValue}${i18n.t('common.unit.second')}`
        break
      case '분':
        value = intValue * 60
        text = `${intValue}${i18n.t('common.unit.minute')}`
        break
      case '시간':
        value = intValue * 60 * 60
        text = `${intValue}${i18n.tc('common.unit.hour', intValue)}`
        break
    }
  }

  return {
    value,
    text
  }
}

export default {
  components: {
    UiSelectbox
  },
  data () {
    return {
      model: null,
      durationStartItems: [],
      durationEndItems: []
    }
  },
  props: [
    'filterOptions',
    'currentFilter'
  ],
  computed: {
  },
  created () {
    this.model = cloneDeep(this.currentFilter)
    this.DURATION_START_ITEMS = DURATIONS.map(item => durationStrToSec(item, this.$i18n))
    this.DURATION_END_ITEMS = DURATIONS.concat(['∞']).map(item => durationStrToSec(item, this.$i18n))
    this.durationStartItems = this.DURATION_START_ITEMS
    this.DURATION_END_ITEMS = this.DURATION_END_ITEMS
  },
  watch: {
    currentFilter (value) {
      this.model = cloneDeep(this.currentFilter)
    },
    'model.sessionGteTime' (value) {
      if (value !== undefined) {
        this.durationEndItems = this.DURATION_END_ITEMS.filter(item => {
          return item.value >= value || item.value === null
        })

        if (this.model.sessionLteTime !== null && value > this.model.sessionLteTime) {
          this.model.sessionLteTime = value
        }
      }
    }
  },
  methods: {
    getOptionItems (key) {
      const defaultItems = []
      let options = null
      switch (key) {
        case 'browser':
        case 'country':
        case 'cvr':
        case 'device':
        case 'os':
          options = defaultItems.concat(this.filterOptions[key])
          options.sort()
          break
        case 'existing':
          options = defaultItems.concat([{
            value: false,
            text: this.$t('common.new')
          },
          {
            value: true,
            text: this.$t('common.revisit')
          }])
          break
        case 'sessionGteTime':
          options = this.DURATION_START_ITEMS
          break
        case 'sessionLteTime':
          options = this.DURATION_END_ITEMS
          break
      }
      options.unshift({
        value: '',
        text: this.$t('common.all')
      })
      return options
    }
  }
}
</script>

<style lang="scss" scoped>
.filter__layer {
  width: 630px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100vh - 60px);

  .filter__scroll {
    position: relative;
    width: 100%;
    max-height: calc(100vh - 60px - 88px);
    margin-bottom: 88px;
    overflow-y: auto;
  }

  .options--wrap {
    margin-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
    box-sizing: border-box;

    &.top {
      padding-bottom: 40px;
      border-bottom: 1px solid #d7d7d7;
    }

    .option__next-page {
      height: 56px;

      #optionNextPage {
        position: relative;
      }
    }

    &.bottom {
      padding-bottom: 25px;

      .row {
        margin-top: 30px;

        &.first-row {
          margin-top: 0;
        }
      }
    }
    .option__duration {
      margin-top: 30px;
    }

    .option__id {
      input {
        width: 270px;
        height: 38px;
        border-radius: 6px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        box-sizing: border-box;
        font-size: 14px;
        padding-left: 12px;
        padding-right: 12px;
        box-sizing: border-box;
      }
    }

    .option__device {
      /deep/ .selected-item {
        text-transform: capitalize;
      }

      /deep/ .item__list {
        text-transform: capitalize;
      }
    }

    .option__os {
      /deep/ .item__list {
        max-height: 150px;
      }
    }

    .option__browser {
      /deep/ .item__list {
        max-height: 150px;
      }
    }

    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        width: 270px;
      }
      .right {
        width: 270px;
      }
    }

    strong {
      font-size: 15px;
      font-weight: bold;
      line-height: 1;
      color: #2f2f2f;
      margin-bottom: 40px;
      display: inline-block;
    }
    label {
      font-size: 13px;
      font-weight: bold;
      line-height: 1;
      color: #767676;
      margin-bottom: 5px;
      display: block;
    }
    select, input {
      width: 270px;
      &.full-size {
        width: 100%;
      }
    }
  }
  .button--wrap {
    padding: 25px 0;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    button {
      @include buttonTypeNormal;
      font-size: 14px;
      font-weight: bold;
      &.btn__apply {
        border: solid 1px $brandColor;
        color: $brandColor;
        &:hover {
          @include hoverStyleColor;
        }
      }
      &.btn__cancel {
        border: solid 1px #bbbbbb;
        color: #444;
        margin-right: 5px;
        &:hover {
          @include hoverStyle;
        }
      }
      &.btn__reset {
        position: absolute;
        top: 0px;
        left: 30px;
        padding-left: 26px;

        .icon {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>
